import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.authService.isLoggedIn()) {
      const requiredRoles = route.data["roles"] as Array<string>;
      if (requiredRoles == null || requiredRoles.length == 0) {
        return true;
      }

      for (const role of requiredRoles) {
        if (this.authService.hasRole(role)) {
          return true;
        }
      }

      return false;
    } else {
      this.router.navigate(['/login']); // Redirect to login if not logged in
      return false;
    }
  }
}